module.exports = __webpack_public_path__ + "img/heaven_and_earth_box4.cbe16896.png";